export default __webpack_public_path__ + "static/media/element_15.418bfc47.webp";